<div [formGroup]="editForm" class="k-form" *ngIf="loaded">
    <button kendoButton [primary]="true" (click)="addTask()" type="button" class="mb-2" *ngIf="!isDeleted">
        {{'ADD-TASK' | translate}}<i class="far fa-plus"></i>
    </button>
    <div formGroupName="tasks" class="container-tasks">
        <table class="table mb-0">
            <thead>
                <tr>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'NAME' | translate }}
                            *
                        </label>
                    </th>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'DUE-DATE' | translate
                            }}
                        </label>
                    </th>
                    <th>
                        <label class="control-label k-text-uppercase dark font-weight-normal">{{ 'PRIORITY' | translate
                            }}
                            *
                        </label>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr style="position:relative;top:10px" *ngIf=" editForm.controls.tasks.controls.length === 0">
                    {{'NO-RULES-SUMMARY' | translate}}
                </tr>
                <tr *ngFor="let task of editForm.controls.tasks.controls; let i=index; trackBy:tasksTrackBy;">
                    <td style="width:55%" [formGroupName]="i">
                        <input kendoTextBox formControlName="name" class="w-100" maxlength="255" />
                        <div class="k-tooltip k-tooltip-validation" role="alert" *ngIf="editForm.controls.tasks.controls[i].controls.name.hasError('required') && 
                                   editForm.controls.tasks.controls[i].controls.name.touched">
                            {{ 'REQUIRED-NAME' | translate }}
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                <label class="mb-0">
                                    <span class="k-text-uppercase dark">
                                        {{'DESCRIPTION' | translate}}
                                    </span>
                                </label>
                                <textarea id="description" kendoTextArea rows="1" formControlName="description"
                                    class="w-100" maxlength="4000">
                                    </textarea>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                <label class="mb-0">
                                    <span class="k-text-uppercase dark">
                                        {{'NOTE' | translate}}
                                    </span>
                                </label>
                                <textarea id="note" kendoTextArea rows="1" formControlName="note" class="w-100"
                                    maxlength="10485760">
                                    </textarea>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12">
                                <label class="mb-0">
                                    <span class="k-text-uppercase dark">
                                        {{'ASSESSMENT' | translate}}
                                    </span>
                                </label>
                                <kendo-combobox id="taskAssessment" formControlName="taskAssessment" class="w-100"
                                    [valuePrimitive]="false" [filterable]="true"
                                    (filterChange)="assessmentFilter($event)" (close)="searchTerm=''"
                                    [itemDisabled]="assessmentItemDisabled" [data]="assessmentsFiltered"
                                    [textField]="'name'" [valueField]="'id'">
                                    <ng-template kendoComboBoxItemTemplate let-dataItem>
                                        <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
                                        </span>
                                    </ng-template>
                                </kendo-combobox>
                            </div>
                        </div>
                        <div class="k-tooltip k-tooltip-validation" role="alert"
                            *ngIf="editForm.controls.tasks.controls[i].controls.importError.value">
                            {{ 'ASSESSMENT-DATA-PARTIALLY-LOADED-HINT' | translate }}
                        </div>
                        <div style="margin-top:10px;">
                            <app-document [memberId]="" [caseId]="" [taskId]="" [taskDefinitionId]="" [bpmId]=""
                                [messageId]=""
                                [assessmentTaskId]="editForm.controls.tasks.controls[i].controls.id.value !== null ? editForm.controls.tasks.controls[i].controls.id.value : 0"
                                [allowEmail]="false">
                            </app-document>
                        </div>
                        <div class="mt-2">
                            <app-formly-designer-rule-edit [ruleIndex]="i" [fields]="fields" [isDeleted]="isDeleted"
                                [showRules]="editForm.controls.tasks.controls[i].controls.showRules.value"
                                [query]="editForm.controls.tasks.controls[i].controls.query.value"
                                (showRulesChanged)="showRulesChanged($event)">
                            </app-formly-designer-rule-edit>
                        </div>
                    </td>
                    <td style="width:20%" [formGroupName]="i">
                        <div class="row">
                            <div class="col-8" style="margin-right:-20px;">
                                <kendo-numerictextbox [format]="'n0'" formControlName="dueDateDays" class="w-100"
                                    [min]="0">
                                </kendo-numerictextbox>
                            </div>
                            <div class="col-4">
                                <div class="pt-2">{{'IN-DAYS' | translate}}</div>
                            </div>
                        </div>
                    </td>
                    <td style="width:25%" [formGroupName]="i">
                        <div>
                            <kendo-combobox class="w-100" [data]="listPriorities" formControlName="priority"
                                [textField]="'text'" [valueField]="'value'">
                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                    <span innerHTML="{{ dataItem.text | uppercase | translate }}">
                                    </span>
                                </ng-template>
                            </kendo-combobox>
                            <div class="k-tooltip k-tooltip-validation" role="alert"
                                *ngIf="editForm.controls.tasks.controls[i].controls.priority.hasError('required') && 
                                                           editForm.controls.tasks.controls[i].controls.priority.touched">
                                {{ 'PRIORITY-REQUIRED' | translate }}
                            </div>
                        </div>
                    </td>
                    <td class="ng-untouched" *ngIf="!isDeleted">
                        <a title="{{ 'DELETE' | translate }}" (click)="removeTask(i)">
                            <i class="fas fa-fw fa-times-circle fa-delete-custom">&nbsp;</i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>